module.exports = __webpack_public_path__ + "static/media/Winter Wyvern.91cb69e1.png";